/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 12.06.24
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {ObjectTypeEnum} from "@shared/Invoice/ObjectTypeEnum";

export default class BaseEntryObjectData extends BaseObject {

	type: ObjectTypeEnum = null


	constructor() {
		super();
	}
}
